import React, { useEffect, useRef } from "react";
import { getRegionLinks } from "./utils";
import { Icon } from "@amzn/storm-ui";
import { useAccountContext } from "./AccountContextProvider";
import { useBundle } from "@amzn/react-arb-tools";
import { spinner } from "@amzn/storm-ui-icons";
import { RegionSection } from "src/components/RegionSection";
import {DesktopSelectorComponentContainer, DesktopEmptyListLabel} from "src/components/styles/SelectorComponentStyling";
import {DesktopListComponentItemContainer} from "src/components/styles/ListComponentStyling";

export const RegionSelectorDesktop: React.VFC = () => {
  const [bundle, isBundleLoading] = useBundle("pages.interstitial");
  const regionListRef = useRef<HTMLDivElement>(null);
  const { selectedAccount, selectedAccountRef } = useAccountContext();
  const managerAccountLinks = getRegionLinks(selectedAccount);
  const isListEmpty = managerAccountLinks.length === 0;

  useEffect(() => {
    if (!isListEmpty && regionListRef.current) {
      regionListRef.current.focus();
    }
  }, [selectedAccount]);

  if (isBundleLoading) {
    return <Icon type={spinner}></Icon>;
  }
  const selectAccountLabel = bundle.getMessage("select_account");
  return (
    <DesktopSelectorComponentContainer>
      {isListEmpty && (<DesktopEmptyListLabel textColor="secondary">{selectAccountLabel}</DesktopEmptyListLabel>)}
      {!isListEmpty && (
        <DesktopListComponentItemContainer aria-label="manager-account-list" data-testid="manager-account-list" tabIndex={0} ref={regionListRef}>
          {managerAccountLinks.map((managerAccountLink) => {
            return (<RegionSection key={managerAccountLink.region} regionLink={managerAccountLink}/>);
          })}
        </DesktopListComponentItemContainer>
      )}
    </DesktopSelectorComponentContainer>
  );
};